import Helper from "@ember/component/helper";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
export default class extends Helper {
  compute([bioExamResultsJe]) {
    return bioExamResultsJe.results.filter(result => result.isAdhoc).length;
  }
}